import { ActionContext, ActionTree } from "vuex";
import { IFareManagementState } from "@/core/interfaces/state/fareManagementState.interface";
import FareManagementService from "@/modules/FareManagement/services/faremanagement.service";
import { StoreState } from "@/store/type";
import notificationService from "@/core/services/notification.service";
import { NOTIFICATION_TYPES } from "@/core/enums/NOTIFICATION_TYPES";
import { StatusCodes } from "http-status-codes";

const actions: ActionTree<IFareManagementState, StoreState> = {
  async fetchSabreFares(
    context: ActionContext<IFareManagementState, StoreState>,
    payload: { pnr: string; airlineCode: string; financialProfile: string },
  ) {
    context.commit("setSabreFaresLoading", true);
    context.commit("resetSabreFares", null);
    try {
      const fareManagementService = new FareManagementService();
      const response = await fareManagementService.getFares(
        payload.pnr,
        payload.airlineCode,
        payload.financialProfile,
      );
      if (
        response.success &&
        response.status === StatusCodes.OK &&
        response.data?.data
      ) {
        context.commit("saveSabreFares", response.data?.data);
      } else {
        throw response;
      }
    } catch (error: any) {
      notificationService.type = NOTIFICATION_TYPES.ERROR;
      notificationService.description = error?.message || "";
      notificationService.triggerNotification();
    } finally {
      context.commit("setSabreFaresLoading", false);
    }
  },
  async applyFares(
    context: ActionContext<IFareManagementState, StoreState>,
    reference: string,
  ) {
    context.commit("setSabreFaresLoading", true);
    try {
      const fareManagementService = new FareManagementService();
      const response = await fareManagementService.saveFares(reference);
      context.commit("setSabreFaresLoading", false);
      context.commit("resetSabreFares", null);
      if (
        response.success &&
        response.status === StatusCodes.OK &&
        response.data?.data
      ) {
        notificationService.type = NOTIFICATION_TYPES.SUCCESS;
        notificationService.description = response.data?.message || "";
        notificationService.triggerNotification();
      } else {
        throw response;
      }
    } catch (error: any) {
      notificationService.type = NOTIFICATION_TYPES.ERROR;
      notificationService.description = error?.message || "";
      notificationService.triggerNotification();
    } finally {
      context.commit("setSabreFaresLoading", false);
    }
  },
};

export default actions;
